//#region src/logger/helpers/isRelevant.ts
var e = (e, t) => t === "error" && e === "error" || t === "warn" && (e === "error" || e === "warn") || t === "info" && (e === "error" || e === "warn" || e === "info") || t === "verbose" && e !== "debug" || t === "debug";
//#endregion
export { e as isRelevant };

//# sourceMappingURL=isRelevant.js.map